import 'css-chunksrc/client/scenes/changePassword/styles.scss';export default {
  "changePassword": "_changePassword_15br9_1",
  "footer": "_footer_15br9_5",
  "button": "_button_15br9_11"
};